module.exports = __webpack_public_path__ + "assets/img/cc38dd857bcd2e9d8c22d3d2ad323118.svg";